import React, { useContext, useEffect, useState, useMemo } from "react";
import {
  MapContainer, Marker, Popup, Tooltip
  , FeatureGroup
  , LayerGroup, LayersControl, WMSTileLayer, TileLayer
  , useMap, useMapEvent, useMapEvents
  , Polyline, Polygon, CircleMarker, Circle, Rectangle
  , ScaleControl, ZoomControl
} from 'react-leaflet'
import L, { tileLayer } from 'leaflet';


import iconMarker from "leaflet/dist/images/marker-icon.png";
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl: iconMarker,
  shadowUrl: iconShadow,
});



export default function DrowArea({ points, getPoints, editable }) {
  const map = useMap();
  const [localPoint, setlocalPoint] = useState([]);

  useEffect(() => {
    if (points)
    setlocalPoint([...points]);
    console.log('map in Points',map)
  }, [points])
   
  
  //useEffect(() => {
  //  console.log('localPoint', localPoint)
  //  getPoints(localPoint);
  //}, [localPoint])



  const checkEnd = (data) => {
    if (!localPoint){
      console.log('checkEnd', localPoint)
      return false;
    }
    let list = data ? data : localPoint;
    return list.length > 1 &&
      list[0][0] == list[list.length - 1][0]
      &&
      list[0][1] == list[list.length - 1][1]
    //return (list.length > 1 && list[0] == list[list.length - 1]) ;
  }

  const [showPolyLineNew, setShowPolyLineNew] = useState(false)
  const map2 = useMapEvents({
    click: (e) => {
      console.log('click map', e);
       L.DomEvent.stopPropagation(e);
      //e.preventDefault();
      //e.stopPropagation();
      const { lat, lng } = e.latlng;
      if (checkEnd()) {
        setShowPolyLineNew(false);
        return; 
      }
       
        
      const temp = localPoint?[...localPoint, [lat, lng]]:[[lat, lng]];
      getPoints(temp);
      setlocalPoint(temp);
      setShowPolyLineNew(true);      
      return ;
    },
    //locationfound:
    //mouseover: (e) => {
    //console.log('mouseover', e)
    //}
  });
  const [coords, setCoords] = useState({});
  const { lat, lng } = coords;
  const dd = (e) => {
    setCoords({ lat: e.latlng.lat, lng: e.latlng.lng });
  }
  useEffect(() => {
    if (!map)
      return;
    map.addEventListener("mousemove", dd);
    return () => map.removeEventListener("mousemove", dd);
  }, [map]);

  const localPointStyle = {
    //fillColor: 'transparent',
    fillOpacity: 0.001,
    //weight: 3,
    color: 'red',
    //opacity: 0.5
  };

  const localPointStyleEnd = {
    //fillColor: 'transparent',
    fillOpacity: 0.001,
    //weight: 3,
    color: 'red',
   // opacity: 0.5
  };

/*
  const customMarker = new L.icon({
    iconUrl: iconMarker,//"https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40]
  });


  const customMarker2 = new L.icon({
    iconRetinaUrl: iconRetina,
    iconUrl: iconMarker,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40]
  });
  */

  const eventHandlers = (e, item, index) => {
    const temp = [...localPoint];
    if ((index == 0 || index == temp.length - 1) && checkEnd(temp)) {
      temp[0] = [e.target._latlng.lat, e.target._latlng.lng];
      temp[temp.length - 1] = temp[0];
    } else
      temp[index] = [e.target._latlng.lat, e.target._latlng.lng];
    setlocalPoint([...temp]);
    getPoints([...temp]);
  }

  const checkNearPoint = (point) => {
    let min = 4000000;
    let index = -1;
    localPoint.map((item, i) => {
      //console.log('distance', map.distance(point, item));
      //console.log('i', i);
      if (map.distance(point, item) < min) {
        min = map.distance(point, item);
        index = i
      }
    })
    //console.log('index', index);
    //console.log('distance min', min);
    return index;
  }

  const addNewPointInPolyon = (point) => {
    let index = checkNearPoint(point);
    const temp = [...localPoint];
    console.log('addNewPointInPolyon index', index)
    if (index == temp.length - 1)
      index = index - 1;
    else if (index == 0)
      index = index + 1;
    console.log('addNewPointInPolyon index2', index);
    temp.splice(index, 0, point);
    setlocalPoint(temp);
    getPoints(temp);
  }
  //const [markerHover, setMarkerHover] = useState(null);

  return (
    <>
      {/*<CircleMarker
                center={item}
                pathOptions={redOptions}
                radius={20}
                key={index + "c"}
                eventHandlers={{ dragend: (e) => { eventHandlers(e, item, index) } }}
               
                draggable={true}>
                <Popup>Popup in CircleMarker</Popup>
              </CircleMarker>
              */
      }
      {editable && localPoint && localPoint.map((item, index) =>
        <Marker
          key={index + "markerDrow"}
          // icon={markerHover == item ? customMarker2 : customMarker}           
          draggable={true}
          position={item}
          eventHandlers={{
            dragend: (e) => { eventHandlers(e, item, index) },
            click: (e) => {
              console.log('click marker', e);
              if (localPoint.length > 1 && item == localPoint[0]) {
                const temp = [...localPoint, item];
                setlocalPoint(temp);
                getPoints(temp);
              }
            },
            drag: (e) => {
              console.log('onDrag marker', e);
              eventHandlers(e, item, index);
            },
            mouseover: () => {
              // console.log('over marker');
              setShowPolyLineNew(false);
              //setMarkerHover(item);
            },
            mouseout: () => {
              //console.log('out marker');
              setShowPolyLineNew(true);
              //setMarkerHover(null);
            },
          }}
        >
          <Tooltip offset={[0, 0]} opacity={1} permanent>{index + 1}</Tooltip>
          {/*
                <CircleMarker
                  center={item}
                  pathOptions={redOptions}
                  radius={20}
                  key={index + "c"}
                  draggable={true}>
                  <Popup>Popup in CircleMarker</Popup>
                </CircleMarker>
              */}
        </Marker>

      )}
      {
        //خط در زمانی که محدوده تکمیل نشده و برای نقطه جدید
      }
      {localPoint  && localPoint.length > 0 && showPolyLineNew && lat && lng  && (localPoint.length == 1 || !checkEnd()) &&
        <Polyline
          positions={[localPoint[localPoint.length - 1], [lat, lng]]}
          color={'red'}
          dashArray={"10, 10"} 
          dashOffset={5} />
      }
      {localPoint && localPoint.length > 0 && checkEnd() &&
        <Polygon
          positions={localPoint}
          pathOptions={localPoint[0] != localPoint[localPoint.length - 1] ? localPointStyle : localPointStyleEnd}
          dashArray={"10, 10"} 
          dashOffset={5} 
          eventHandlers={{
            click: (e) => {
              //e.preventDefault();
              L.DomEvent.stopPropagation(e);
              console.log('click Line', e);
              addNewPointInPolyon(e.latlng);
            },
            mouseover: () => { console.log('over polygon'); setShowPolyLineNew(false) },
            mouseout: () => { console.log('out polygon'); setShowPolyLineNew(true) },
          }}
        />}
      {localPoint && localPoint.length > 0 && !checkEnd() &&
        <Polyline
          positions={localPoint}
          color={'green'}
          dashArray={"10, 10"} 
          dashOffset={5} 
        />}

    </>
  )
}

